"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHidePeriodExpired = exports.formatJa = exports.toDate = void 0;
var date_fns_1 = require("date-fns");
var locale_1 = require("date-fns/locale");
var HIDE_PERIOD_HOUR = 10; // Hide period expires at 10:00 AM next day
var toDate = function (date) {
    if (typeof date !== 'string')
        return date;
    var parsed = (0, date_fns_1.parseISO)(date);
    return isNaN(parsed.getTime()) ? null : parsed;
};
exports.toDate = toDate;
var formatJa = function (date, formatStr) {
    var parsedDate = (0, exports.toDate)(date);
    if (!parsedDate)
        return '';
    return (0, date_fns_1.format)(parsedDate, formatStr, { locale: locale_1.ja });
};
exports.formatJa = formatJa;
var calcHidePeriodEnd = function (date) {
    var openedAt = (0, exports.toDate)(date);
    if (!openedAt)
        return null;
    var nextDay = (0, date_fns_1.addDays)((0, date_fns_1.startOfDay)(openedAt), 1);
    return (0, date_fns_1.addHours)(nextDay, HIDE_PERIOD_HOUR);
};
var isHidePeriodExpired = function (lastOpenedAt) {
    var hidePeriodEnd = calcHidePeriodEnd(lastOpenedAt);
    if (!hidePeriodEnd)
        return true;
    return (0, date_fns_1.isAfter)(new Date(), hidePeriodEnd);
};
exports.isHidePeriodExpired = isHidePeriodExpired;
